import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  activeLanguage: string = 'de';

  constructor() { }
}
